<script>
export default {
  data() {
    return {
      existingUser: 0,
      registered: false,
      showPassword: false
    };
  },

  methods: {
    submit($event, originalOnSubmit) {
      var promise = originalOnSubmit($event);

      var vm = this;

      promise
        .then(function(result) {
          vm.registered = true;
        })
        .catch(() => {});
    }
  }
};
</script>
